import React, { useEffect, useState } from 'react';
import AuthService from '../../services/api/auth';
import FiscalCodeForm from '../../components/fiscalCode';
import { PROVINCE as provinceList } from '../../helpers/fiscal-code/province-list';
import { connect } from 'react-redux';
import CodiceFiscale from 'codice-fiscale-js';
import LoadingModal from '../../components/LoadingModal';

const FiscalCodeScreen = ({ populateForm, fiscalCodeValues, history, location, setStep }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isFiscalCodeValid, setIsFiscalCodeValid] = useState(false);

    const getProvinceOptions = () =>
        Object.entries(provinceList).map(item => {
            return { value: item[0], label: item[1] };
        });
    let provinceOptions = getProvinceOptions();
    const esteroValue = 'EE';
    const esteroOption = provinceOptions.find(p => p.value === esteroValue);
    if (esteroOption) {
        provinceOptions = provinceOptions.filter(p => p.value !== esteroValue);
        provinceOptions = [{ value: '', label: '' }, esteroOption, ...provinceOptions];
    } else {
        provinceOptions = [{ value: '', label: '' }, ...provinceOptions];
    }

    useEffect(() => {
        setStep('FC');
        const fn = async () => {
            let userDetails;
            try {
                userDetails = await AuthService.getPersonalDetails();
                const { GivenName, Surname, BirthDate, Sex } = userDetails;
                userDetails = {
                    name: GivenName,
                    surname: Surname,
                    gender: Sex,
                    birthDate: BirthDate,
                    birthPlace: '',
                    birthPlaceProvince: '',
                    fiscalCode: '',
                };
                populateForm(userDetails, 'fiscalCode');
                setIsLoading(false);
            } catch (error) {
                console.log('error', error);
            }
        };
        fn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cancel = async () => {
        await AuthService.getAccountStatus().then(response => {
            response.steps.forEach((entry, i) => {
                if (entry.path === location.pathname) {
                    if (entry.back) {
                        history.push(entry.back);
                    } else {
                        const lastScreen = response.steps[i - 1];
                        if (lastScreen && lastScreen.path) {
                            history.push(lastScreen.path);
                        }
                    }
                }
            });
        });
    };

    const onSubmit = async () => {
        try {
            const esteroValue = 'EE';
            const birthPlaceProvince = provinceOptions.find(p => p.value === fiscalCodeValues?.birthPlaceProvince);
            let birthplaces = { ProvinceRegionBirth: birthPlaceProvince };
            if (fiscalCodeValues?.birthPlaceProvince === esteroValue) {
                birthplaces = { ...birthplaces, CountryBirth: fiscalCodeValues?.birthPlace };
            } else {
                birthplaces = { ...birthplaces, CityBirth: fiscalCodeValues?.birthPlace };
            }
            const response = await Promise.all([
                AuthService.setFiscalCode(fiscalCodeValues.fiscalCode),
                AuthService.savePersonalBirthplaces(birthplaces),
            ]);
            response[0] && response[0].next ? history.push(response[0].next) : history.push('/register/status');
        } catch (error) {
            console.error({ error });
        }
    };

    const isNextBtnDisabled = () => {
        if (!fiscalCodeValues || !fiscalCodeValues.fiscalCode) {
            isFiscalCodeValid && setIsFiscalCodeValid(false);
        }
        try {
            new CodiceFiscale(fiscalCodeValues.fiscalCode);
            !isFiscalCodeValid && setIsFiscalCodeValid(true);
        } catch (e) {
            isFiscalCodeValid && setIsFiscalCodeValid(false);
        }
        return !isFiscalCodeValid || !fiscalCodeValues?.birthPlace || !fiscalCodeValues?.birthPlaceProvince;
    };

    return (
        <>
            {isLoading && <LoadingModal loading={isLoading} />}
            {!isLoading && (
                <div className="container-fluid wrapper">
                    <div className="d-flex flex-column full-height menu-bar-bottom">
                        <h3 className="page__title">{window.VULOG_TRANSLATE('Calculate Fiscal Code')}</h3>

                        <div className="f-container flex-grow-1">
                            <FiscalCodeForm
                                handleSubmit={onSubmit}
                                provinceOptions={provinceOptions}
                                fiscalCodeValues={fiscalCodeValues}
                                populateForm={populateForm}
                            />
                        </div>
                        <div className="alert alert-info" role="alert">
                            {window.VULOG_TRANSLATE('fiscal_code_info')}
                        </div>
                        <div className="d-flex flex-row mt-auto mb-1-5rem">
                            <button className="btn btn-primary btn-block" onClick={cancel}>
                                <i className="material-icons va-middle reg">keyboard_arrow_left</i>
                                {window.VULOG_TRANSLATE('Back')}
                            </button>
                            <button
                                className="btn btn-primary btn-block"
                                onClick={onSubmit}
                                disabled={isNextBtnDisabled()}
                            >
                                {window.VULOG_TRANSLATE('Next')}
                                <i className="material-icons va-middle reg">keyboard_arrow_right</i>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const mapStatetoProps = state => ({
    fiscalCodeValues: state.form['fiscal-code'] && state.form['fiscal-code'].values,
});

export default connect(mapStatetoProps)(FiscalCodeScreen);
